<div class="summary-header" [ngClass]="{ 'color-primary': color === 'primary', 'color-gray': color === 'gray' }">
  <uni-summary-group [alignment]="alignment">
    <ng-content></ng-content>
  </uni-summary-group>
</div>
